import IconBase from "../IconBase";

const XIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M18.9 1H22.5806L14.5406 10.2126L24 22.7509H16.5943L10.7897 15.148L4.15543 22.7509H0.471429L9.07029 12.8937L0 1.00171H7.59429L12.8331 7.94971L18.9 1ZM17.6057 20.5429H19.6457L6.48 3.09314H4.29257L17.6057 20.5429Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default XIcon;
